module.exports = __webpack_public_path__ + "img/image55.7f47b966.png";